export default __webpack_public_path__ + "static/media/blob1.9839a073.webp";